import { faSave, faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface IProps {
	handleSave: () => void;
	isLoading: boolean;
}

const BtnSave = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<>
			<div role="group" data-component-type="save-button">
				{props.isLoading ? (
					<button type="button" className="btn btn-primary" style={{ width: '2.5rem', height: '2.5rem', fontSize: '0.8rem' }} disabled={true}>
						<FontAwesomeIcon className="fa-spin" icon={faSync} />
					</button>
				) : (
					<button type="button" className="btn btn-primary" style={{ width: '2.5rem', height: '2.5rem', fontSize: '0.8rem' }} onClick={props.handleSave}>
						<FontAwesomeIcon icon={faSave} />
					</button>
				)}
			</div>
		</>
	);
};

export default BtnSave;
